import { Role } from '@/core/collections/modules/roles/role.interface';
import { http } from '@/core/helpers/http.helper';
import { Module } from './../../modules/module.interface';
export class RoleService {
   async getRoles(teamId: number) {
      const response = await http.get<Array<Module>>(`/teams/${teamId}/roles`);
      return response.data;
   }

   async postRolesBatch(teamId: number, roles: Array<Role>) {
      const response = await http.post<Array<Module>>(`/teams/${teamId}/roles-batch`, { roles });
      return response.data;
   }

   async deleteRolesBatch(teamId: number, roles: Array<Role>) {
      const response = await http.delete<Array<Module>>(`/teams/${teamId}/roles-batch`, { data: { roles } });
      return response.data;
   }

   async getRole() {
      throw Error('Method not implemented');
   }

   async postRole() {
      throw Error('Method not implemented');
   }

   async putRole() {
      throw Error('Method not implemented');
   }

   async deleteRole() {
      throw Error('Method not implemented');
   }
}
